module.exports = __webpack_public_path__ + "static/media/cart-black.fea435e0.svg";